<template>
<div class="vliveContentVliveImageText">
    <div class="title">{{item.livesubject}}</div>
    <div v-html="item.content"></div>
</div>
</template>

<script>
import {getVliveContentImgText} from 'api/api'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'vliveContentVliveImageText',
    data() {
        return {
            item: {}
        }
    },
    mounted() {
    },
    methods: {
        // 获取图片合集
        _getGroupVliveImageText(innerid) {
            this.setLoading(true)
            getVliveContentImgText({
                data: {innerid: innerid},
                success: data => {
                    this.item = data.data
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'vliveModel',
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.vliveContentVliveImageText {
    .title{
        padding: 20px 0;
    }
}
</style>
